import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import { g1, g2, g3, g4 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------- SEO helpers ---------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// Порядок атрибутов: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Games = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

  // оставляю твою, чтобы ничего не ломать
  function setMetaTag(name, content) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (element) {
      element.setAttribute("content", content);
    } else {
      element = document.createElement("meta");
      element.name = name;
      element.content = content;
      document.head.appendChild(element);
    }
  }

useEffect(() => {
  // ===== Статические тексты (EN → BN перевод уже дан) =====
  const titleEN = " HHBD Games — Crash, Cards & Instant Win Games BD";
  const descEN =
    "Play all your favorite casino games at HHBD — Crash, Mines, Teen Patti, Andar Bahar & more. Enjoy fair results, real BDT payouts, and 24/7 Bangla support. Easy deposits and withdrawals with bKash & Nagad.";

  const titleBN = "HHBD গেমস — ক্র্যাশ, কার্ড এবং ইনস্ট্যান্ট উইন গেমস বিডি";
  const descBN =
    "HHBD-তে আপনার পছন্দের সব ক্যাসিনো গেম খেলুন — ক্র্যাশ, মাইনস, তিন পট্টি, অন্দর বাহার এবং আরও অনেক কিছু। ন্যায্য ফলাফল, আসল টাকা পরিশোধ এবং 24/7 বাংলা সাপোর্ট উপভোগ করুন। বিকাশ এবং নগদের মাধ্যমে সহজে জমা এবং উত্তোলন।";

  const keywordsEN =
    "HHBD Games, crash game BD, card games Bangladesh, roulette BD, casino app Bangladesh, BDT casino games, play online casino BD";
  const keywordsBN =
    "HHBD গেমস, ক্র্যাশ গেম, কার্ড গেম বিডি, রুলেট গেম, ক্যাসিনো অনলাইন, ক্যাসিনো অ্যাপ বাংলাদেশ";

  const isBN = lang === "bn";

  // ===== Требование: все ТАЙТЛЫ (document/OG/Twitter) — UPPERCASE =====
  const pageTitle = (isBN ? titleBN : titleEN).toUpperCase();  // ✅
  const pageDesc = isBN ? descBN : descEN;                     // обычный регистр
  const pageKeywords = isBN ? keywordsBN : keywordsEN;         // обычный регистр

  // базовые <title> и meta
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaTag("description", pageDesc);        // обычный регистр
  setMetaTag("keywords", pageKeywords);       // обычный регистр

  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // Canonical + hreflang (+ x-default)
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // -------- Open Graph --------
  const ogImage = toAbsoluteUrl(g1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);      // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc); // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? titleBN : titleEN); // alt — читаемый
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // -------- Twitter (полный комплект + twitter:url) --------
  const twitterSite = "@HHBD_official";     // замените на реальный @
  const twitterCreator = "@HHBD_official";  // при необходимости
  const twitterImageAlt = isBN
    ? "HHBD গেমস - মসৃণ গেমপ্লে এবং আসল BDT পুরষ্কারের সাথে অনলাইনে ক্র্যাশ, কার্ড এবং রুলেট খেলুন।"
    : "HHBD Games – play crash, cards and roulette online with smooth gameplay and real BDT prizes.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);         // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);    // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);       // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // Доп. data-pairs (до 2-х)
  setMetaName("twitter:label1", isBN ? "গেম ক্যাটাগরি" : "Categories");
  setMetaName("twitter:data1", "Crash, Cards, Roulette, Slots");
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");


  
}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/games";

      // Page copy (names/descriptions in JSON-LD must be UPPERCASE per your rule)
      const titleEN = " HHBD Games — Crash, Cards & Instant Win Games BD";
      const descEN =
        "Play all your favorite casino games at HHBD — Crash, Mines, Teen Patti, Andar Bahar & more. Enjoy fair results, real BDT payouts, and 24/7 Bangla support. Easy deposits and withdrawals with bKash & Nagad.";
      const titleBN = "HHBD গেমস — ক্র্যাশ, কার্ড এবং ইনস্ট্যান্ট উইন গেমস বিডি";
      const descBN =
        "HHBD-তে আপনার পছন্দের সব ক্যাসিনো গেম খেলুন — ক্র্যাশ, মাইনস, তিন পট্টি, অন্দর বাহার এবং আরও অনেক কিছু। ন্যায্য ফলাফল, আসল টাকা পরিশোধ এবং 24/7 বাংলা সাপোর্ট উপভোগ করুন। বিকাশ এবং নগদের মাধ্যমে সহজে জমা এবং উত্তোলন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";


      // Use g1 as primary image; fall back to favicon if needed
      const ogImage =
        typeof g1 === "string"
          ? (/^https?:\/\//i.test(g1) ? g1 : `${origin}${g1.startsWith("/") ? "" : "/"}${g1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {g1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl as requested)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
 <>
    <section className="zHHBD-gameshero">
      <div className="zHHBD-gameshero__bg">
        <div className="zHHBD-gameshero__overlay"></div>
        <div className="zHHBD-gameshero__spark zHHBD-gameshero__spark--1"></div>
        <div className="zHHBD-gameshero__spark zHHBD-gameshero__spark--2"></div>
      </div>

      <div className="zHHBD-gameshero__container">
        <div className="zHHBD-gameshero__content">
          <header className="zHHBD-gameshero__header">
            <h1 className="zHHBD-gameshero__title">
              HHBD Games – All Casino Fun in One Place
            </h1>
            <p className="zHHBD-gameshero__desc">
              Step into the HHBD gaming universe, a hub where players across Bangladesh can instantly find a perfect match.
              Our sweeping library features thousands of{" "}
              <Link to="/casino" className="zHHBD-gameshero__link" data-discover="true">casino</Link>{" "}
              <Link to="/games" className="zHHBD-gameshero__link" data-discover="true">games</Link>—from adrenaline-fueled{" "}
              <Link to="/slots" className="zHHBD-gameshero__link" data-discover="true">slots</Link> and strategy-first table{" "}
              <Link to="/games" className="zHHBD-gameshero__link" data-discover="true">games</Link> to immersive live studios and distinctive instant-win thrills.
              Dive into variety, excitement, and powerful chances to win at every turn of play.
            </p>
          </header>

          <div className="zHHBD-gameshero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-gameshero__btn zHHBD-gameshero__btn--main"
              title="Join HHBD Now"
            >
              Join HHBD Now
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-gameshero__btn zHHBD-gameshero__btn--ghost"
              title="Download APK"
            >
              Download APK
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Games – Discover top-tier online casino experiences in Bangladesh"
        >
          <img
            src={g1}
            alt="Stylish player relaxing in a neon lounge while enjoying online poker on the HHBD platform."
            title="HHBD Games – Discover top-tier online casino experiences in Bangladesh"
          />
        </a>
      </div>
    </section>

    {/* Experience Section */}
    <section className="zHHBD-experience">
      <div className="zHHBD-experience__bg">
        <div className="zHHBD-experience__shape HHBD-experience__shape--1"></div>
        <div className="zHHBD-experience__shape HHBD-experience__shape--2"></div>
        <div className="zHHBD-experience__stars"></div>
      </div>

      <div className="container hr-cont">
        <h2 className="zHHBD-experience__title">At HHBD, There’s a Game That Fits Every Player</h2>
        <p className="zHHBD-experience__desc">
          We believe breadth fuels a superior online{" "}
          <Link to="/casino" className="zHHBD-experience__link" data-discover="true">casino</Link> journey.
          That’s why we’ve assembled a vast, diverse portfolio of{" "}
          <Link to="/games" className="zHHBD-experience__link" data-discover="true">games</Link> for every mood, tempo, and skill level.
          Whether you want a few quick spins on{" "}
          <Link to="/slots" className="zHHBD-experience__link" data-discover="true">slots</Link> or you’re hunting a tactical edge at the felt, your perfect destination is right here.
        </p>
      </div>
      <header className="zHHBD-experience__header"></header>
      <div className="zHHBD-experience__container">
        <div className="zHHBD-experience__inner">
          {/* Left Side Image & Animations */}
          <div className="zHHBD-experience__visual">
            <div className="zHHBD-experience__imgbox">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD Games – Explore live dealer roulette and tables in Bangladesh"
              >
                <img
                  src={g2}
                  alt="Player enjoying live roulette on HHBD with neon accents and a vibrant backdrop."
                  title="HHBD Games – Explore live dealer roulette and tables in Bangladesh"
                  className="zHHBD-experience__img"
                />
              </a>
              <div className="zHHBD-experience__glow"></div>
              <div className="zHHBD-experience__badge">
                Your Complete Gaming Universe
              </div>
            </div>
          </div>
          {/* Right Side Content */}
          <div className="zHHBD-experience__content">
            <div className="zHHBD-experience__descbox">
              <p className="zHHBD-experience__desc">
                Discovering fresh{" "}
                <Link to="/games" className="zHHBD-experience__link" data-discover="true">games</Link> is effortless with our smart find-and-filter tools.
                Sort by provider, popularity, or category to surface exactly what you want—plus a spotlight for brand-new launches,
                so you can try cutting-edge{" "}
                <Link to="/games" className="zHHBD-experience__link" data-discover="true">games</Link> the moment they arrive.
              </p>
              <p className="zHHBD-experience__desc">
                Quality is non-negotiable. Every{" "}
                <Link to="/games" className="zHHBD-experience__link" data-discover="true">game</Link> at HHBD comes from licensed, respected studios to guarantee fairness, security, and striking presentation.
                Our standards show in an entertainment lineup that looks superb and runs flawlessly each time you play.
              </p>
            </div>
            <div className="zHHBD-experience__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-experience__btn"
                title="Play HHBD Games"
              >
                Play HHBD Games
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Game Style Section */}
    <section className="zHHBD-gamestyle">
      <div className="zHHBD-gamestyle__bg">
        <div className="zHHBD-gamestyle__burst HHBD-gamestyle__burst--1"></div>
        <div className="zHHBD-gamestyle__burst HHBD-gamestyle__burst--2"></div>
      </div>
      <div className="zHHBD-gamestyle__container">
        <header className="zHHBD-gamestyle__header">
          <h2 className="zHHBD-gamestyle__title">
            Explore Our Core Game Categories
          </h2>
          <p className="zHHBD-gamestyle__intro">
            We’ve organized the library into clear sections so you can zero in on your favourites fast.
            Each category contains hundreds of titles, giving you limitless room to browse, compare, and enjoy at your own pace.
          </p>
        </header>

        <div className="zHHBD-action__cards-body">
          <div className="zHHBD-gamestyle__cards">
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">Online Slots</h3>
              <p className="zHHBD-gamestyle__card-text">
                Spin through thousands of online{" "}
                <Link to="/slots" className="zHHBD-gamestyle__link" data-discover="true">slots</Link>.
                From nostalgic fruit machines to cinematic video{" "}
                <Link to="/slots" className="zHHBD-gamestyle__link" data-discover="true">slots</Link> packed with features, bonuses, and stunning visuals,
                you’ll find a journey that matches your imagination.
              </p>
            </div>
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">Live Casino</h3>
              <p className="zHHBD-gamestyle__card-text">
                Enjoy a real-deal{" "}
                <Link to="/casino" className="zHHBD-gamestyle__link" data-discover="true">casino</Link> ambiance with live dealer{" "}
                <Link to="/games" className="zHHBD-gamestyle__link" data-discover="true">games</Link>.
                Play Roulette, Blackjack, and Baccarat with professional croupiers streamed in crisp HD for an authentic session.
              </p>
            </div>
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">Instant Win &amp; Crash Games</h3>
              <p className="zHHBD-gamestyle__card-text">
                Craving quickfire fun? Our instant-win and crash{" "}
                <Link to="/games" className="zHHBD-gamestyle__link" data-discover="true">games</Link> bring pace and adrenaline.
                Test timing and nerve with favourites like{" "}
                <Link to="/aviator" className="zHHBD-gamestyle__link" data-discover="true">Aviator</Link>, Lucky Jet, and more arcade-style{" "}
                <Link to="/games" className="zHHBD-gamestyle__link" data-discover="true">games</Link> engineered for rapid action.
              </p>
            </div>
          </div>
          <figure className="zHHBD-gamestyle__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Games – Jump into vivid slots and timeless card play with HHBD Bangladesh"
            >
              <img
                src={g3}
                alt="Young gamer immersed in a neon world of cards and chips on the HHBD platform."
                title="HHBD Games – Jump into vivid slots and timeless card play with HHBD Bangladesh"
                className="zHHBD-gamestyle__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-gamestyle__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-gamestyle__btn"
            title="Start Exploring Our Games"
          >
            Start Exploring Our Games
          </a>
        </div>
      </div>
    </section>

    {/* Hot Now / Crash & Arcade Section */}
    <section className="zHHBD-hotnow">
      <div className="zHHBD-hotnow__bg">
        <div className="zHHBD-hotnow__burst HHBD-hotnow__burst--1"></div>
        <div className="zHHBD-hotnow__burst HHBD-hotnow__burst--2"></div>
      </div>
      <div className="zHHBD-hotnow__container">
        <header className="zHHBD-hotnow__header">
          <h2 className="zHHBD-hotnow__title">
            Powered by World-Class Game Studios
          </h2>
        </header>
        <p className="zHHBD-hotnow__intro">
          The strength of our{" "}
          <Link to="/games" className="zHHBD-hotnow__link" data-discover="true">games</Link> comes from close collaboration with industry-leading creators.
          These partners are celebrated for innovation, artistry, and certified integrity.
          Together, we deliver a premium{" "}
          <Link to="/casino" className="zHHBD-hotnow__link" data-discover="true">casino</Link> experience loaded with standout titles and trusted technology.
        </p>
        <div className="zHHBD-hotnow__grid">
          <div className="zHHBD-hotnow__card">
            <h3 className="zHHBD-hotnow__card-title">Innovation at the Forefront</h3>
            <p className="zHHBD-hotnow__card-text">
              Our studio network keeps the library fresh with constant releases and inventive mechanics.
              You’ll never be stuck replaying the same{" "}
              <Link to="/games" className="zHHBD-hotnow__link" data-discover="true">games</Link>;
              instead, you’ll regularly discover new themes to explore, new ways to play, and new routes to chase big wins.
            </p>
          </div>
        </div>
        <div className="zHHBD-hotnow__cta">
          <a
            href="https://haruvest.com/fPdbvXy9"
            className="zHHBD-hotnow__btn"
            title="Play HHBD Games"
          >
            Play HHBD Games
          </a>
        </div>
        <figure className="zHHBD-hotnow__figure">
          <a
            href="https://haruvest.com/VRfKYjYj9"
            title="HHBD Games – Explore premium online casino titles in Bangladesh"
          >
            <img
              src={g4}
              alt="Trendy player in a neon casino scene, playing online poker on the HHBD platform."
              title="HHBD Games – Explore premium online casino titles in Bangladesh"
              className="zHHBD-hotnow__img"
            />
          </a>
        </figure>
      </div>
    </section>
  </>



      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
<>
    <section className="zHHBD-gameshero">
      <div className="zHHBD-gameshero__bg">
        <div className="zHHBD-gameshero__overlay"></div>
        <div className="zHHBD-gameshero__spark zHHBD-gameshero__spark--1"></div>
        <div className="zHHBD-gameshero__spark zHHBD-gameshero__spark--2"></div>
      </div>

      <div className="zHHBD-gameshero__container">
        <div className="zHHBD-gameshero__content">
          <header className="zHHBD-gameshero__header">
            <h1 className="zHHBD-gameshero__title">
             HHBD গেমস - এক জায়গায় সব ক্যাসিনোর মজা
            </h1>
            <p className="zHHBD-gameshero__desc">
              ঢুকে পড়ুন HHBD গেমিং ইউনিভার্সে—বাংলাদেশ জুড়ে প্লেয়াররা যেখানে মুহূর্তেই নিজেদের পছন্দমতো খেলা খুঁজে পান।
              আমাদের বিশাল লাইব্রেরিতে রয়েছে হাজারো{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link" data-discover="true">ক্যাসিনো</Link>{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link>—অ্যাড্রেনালিনভরা{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> ও কৌশল-নির্ভর টেবিল{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> থেকে ইমার্সিভ লাইভ স্টুডিও এবং আলাদা ধরনের ইনস্ট্যান্ট-উইন থ্রিল পর্যন্ত।
              বৈচিত্র্য, উত্তেজনা—আর প্রতিটি টার্নে বড় জেতার দারুণ সুযোগ—সবই একসাথে উপভোগ করুন।
            </p>
          </header>

          <div className="zHHBD-gameshero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-gameshero__btn zHHBD-gameshero__btn--main"
              title="এখনই HHBD-এ যোগ দিন"
            >
              এখনই HHBD-এ যোগ দিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-gameshero__btn zHHBD-gameshero__btn--ghost"
              title="APK ডাউনলোড করুন"
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD গেমস – বাংলাদেশে সেরা অনলাইন ক্যাসিনো অভিজ্ঞতা আবিষ্কার করুন"
        >
          <img
            src={g1}
            alt="নীয়ন লাউঞ্জে আরাম করে HHBD প্ল্যাটফর্মে অনলাইন পোকার খেলছেন এক স্টাইলিশ প্লেয়ার।"
            title="HHBD গেমস – বাংলাদেশে সেরা অনলাইন ক্যাসিনো অভিজ্ঞতা আবিষ্কার করুন"
          />
        </a>
      </div>
    </section>

    {/* Experience Section */}
    <section className="zHHBD-experience">
      <div className="zHHBD-experience__bg">
        <div className="zHHBD-experience__shape HHBD-experience__shape--1"></div>
        <div className="zHHBD-experience__shape HHBD-experience__shape--2"></div>
        <div className="zHHBD-experience__stars"></div>
      </div>

      <div className="container hr-cont">
        <h2 className="zHHBD-experience__title">HHBD-এ প্রতিটি প্লেয়ারের জন্য আছে উপযুক্ত গেম</h2>
        <p className="zHHBD-experience__desc">
          আমাদের বিশ্বাস—বৈচিত্র্যই সেরা অনলাইন{" "}
          <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link" data-discover="true">ক্যাসিনো</Link> অভিজ্ঞতার জ্বালানি।
          সে কারণেই আমরা সাজিয়েছি বিস্তৃত ও বহুমাত্রিক{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> পোর্টফোলিও—প্রতিটি মুড, গতি ও দক্ষতার স্তরের জন্য।
          কয়েক দফা দ্রুত স্পিন দিতে চাইলে{" "}
          <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> বেছে নিন; কৌশলগত এজ খুঁজলে টেবিলেই মিলবে আপনার গন্তব্য।
        </p>
      </div>
      <header className="zHHBD-experience__header"></header>
      <div className="zHHBD-experience__container">
        <div className="zHHBD-experience__inner">
          {/* Left Side Image & Animations */}
          <div className="zHHBD-experience__visual">
            <div className="zHHBD-experience__imgbox">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD গেমস – বাংলাদেশে লাইভ রুলেট ও ডিলার টেবিল আবিষ্কার করুন"
              >
                <img
                  src={g2}
                  alt="নীয়ন অ্যাকসেন্টে ভরপুর ব্যাকড্রপ—HHBD-এ লাইভ রুলেট উপভোগ করছেন এক প্লেয়ার।"
                  title="HHBD গেমস – বাংলাদেশে লাইভ রুলেট ও ডিলার টেবিল আবিষ্কার করুন"
                  className="zHHBD-experience__img"
                />
              </a>
              <div className="zHHBD-experience__glow"></div>
              <div className="zHHBD-experience__badge">
                আপনার সম্পূর্ণ গেমিং ইউনিভার্স
              </div>
            </div>
          </div>
          {/* Right Side Content */}
          <div className="zHHBD-experience__content">
            <div className="zHHBD-experience__descbox">
              <p className="zHHBD-experience__desc">
                নতুন{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> খুঁজে পাওয়া अब সহজ—আমাদের স্মার্ট ফাইন্ড-এন্ড-ফিল্টার টুল দিয়ে।
                প্রোভাইডার, পপুলারিটি বা ক্যাটাগরি অনুযায়ী সাজিয়ে নিন—সাথে নতুন লঞ্চের জন্য আলাদা স্পটলাইট,
                যাতে কাটিং-এজ{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> রিলিজ হওয়ার মুহূর্তেই খেলতে পারেন।
              </p>
              <p className="zHHBD-experience__desc">
                কোয়ালিটিতে আপস নয়। HHBD-এর প্রতিটি{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেম</Link> আসে লাইসেন্সপ্রাপ্ত ও বিশ্বস্ত স্টুডিও থেকে—ফেয়ারনেস, সিকিউরিটি ও দুর্দান্ত উপস্থাপনা নিশ্চিত করে।
                ফলাফল—প্রতিবার খেললেই স্মুথ পারফরম্যান্স আর চমৎকার ভিজ্যুয়ালসসহ বিনোদনের দারুণ লাইনআপ।
              </p>
            </div>
            <div className="zHHBD-experience__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-experience__btn"
                title="HHBD গেমস খেলুন"
              >
                HHBD গেমস খেলুন
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Game Style Section */}
    <section className="zHHBD-gamestyle">
      <div className="zHHBD-gamestyle__bg">
        <div className="zHHBD-gamestyle__burst HHBD-gamestyle__burst--1"></div>
        <div className="zHHBD-gamestyle__burst HHBD-gamestyle__burst--2"></div>
      </div>
      <div className="zHHBD-gamestyle__container">
        <header className="zHHBD-gamestyle__header">
          <h2 className="zHHBD-gamestyle__title">
            আমাদের মূল গেম ক্যাটাগরি অন্বেষণ করুন
          </h2>
          <p className="zHHBD-gamestyle__intro">
            আমরা লাইব্রেরিটি পরিষ্কার সেকশনে সাজিয়েছি—যাতে প্রিয় বিনোদনে দ্রুত ফোকাস করতে পারেন।
            প্রতিটি ক্যাটাগরিতে শত শত টাইটেল—ইচ্ছেমতো ব্রাউজ, তুলনা ও উপভোগ করুন আপনার গতিতে।
          </p>
        </header>

        <div className="zHHBD-action__cards-body">
          <div className="zHHBD-gamestyle__cards">
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">অনলাইন স্লটস</h3>
              <p className="zHHBD-gamestyle__card-text">
                হাজারো অনলাইন{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> ঘুরুন।
                নস্টালজিক ফ্রুট মেশিন থেকে শুরু করে সিনেম্যাটিক ভিডিও{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>—ফিচার, বোনাস ও চমৎকার ভিজ্যুয়ালে ভরপুর—
                আপনার কল্পনার সঙ্গে মানানসই একেকটা যাত্রা খুঁজে পাবেন।
              </p>
            </div>
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">লাইভ ক্যাসিনো</h3>
              <p className="zHHBD-gamestyle__card-text">
                সত্যিকারের{" "}
                <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link" data-discover="true">ক্যাসিনো</Link> আবহ উপভোগ করুন লাইভ ডিলার{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> এর সঙ্গে।
                প্রফেশনাল ক্রুপিয়ারদের HD স্ট্রিমে Roulette, Blackjack, Baccarat খেলুন—খাঁটি লাইভ সেশন।
              </p>
            </div>
            <div className="zHHBD-gamestyle__card">
              <h3 className="zHHBD-gamestyle__card-title">ইনস্ট্যান্ট উইন ও ক্র্যাশ গেমস</h3>
              <p className="zHHBD-gamestyle__card-text">
                দ্রুত-গতির মজা চাই? আমাদের ইনস্ট্যান্ট-উইন ও ক্র্যাশ{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> আনবে গতি আর অ্যাড্রেনালিন।
                টাইমিং ও নার্ভ পরীক্ষা করুন জনপ্রিয়{" "}
                <Link to={getLangPath("/aviator", lang)} className="rr555-aviatorlux__link" data-discover="true">Aviator</Link>, Lucky Jet সহ আরও আর্কেড-স্টাইল{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> দিয়ে—ঝটপট অ্যাকশনের জন্য ইঞ্জিনিয়ার্ড।
              </p>
            </div>
          </div>
          <figure className="zHHBD-gamestyle__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD গেমস – উজ্জ্বল স্লটস ও চিরন্তন কার্ডপ্লেতে ঝাঁপ দিন"
            >
              <img
                src={g3}
                alt="কার্ড ও চিপসে ভরা নীয়ন দুনিয়ায় নিমগ্ন তরুণ গেমার—HHBD প্ল্যাটফর্মে।"
                title="HHBD গেমস – উজ্জ্বল স্লটস ও চিরন্তন কার্ডপ্লেতে ঝাঁপ দিন"
                className="zHHBD-gamestyle__img"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-gamestyle__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-gamestyle__btn"
            title="আমাদের গেমস এক্সপ্লোর করা শুরু করুন"
          >
            আমাদের গেমস এক্সপ্লোর করা শুরু করুন
          </a>
        </div>
      </div>
    </section>

    {/* Hot Now / Crash & Arcade Section */}
    <section className="zHHBD-hotnow">
      <div className="zHHBD-hotnow__bg">
        <div className="zHHBD-hotnow__burst HHBD-hotnow__burst--1"></div>
        <div className="zHHBD-hotnow__burst HHBD-hotnow__burst--2"></div>
      </div>
      <div className="zHHBD-hotnow__container">
        <header className="zHHBD-hotnow__header">
          <h2 className="zHHBD-hotnow__title">
            ওয়ার্ল্ড-ক্লাস গেম স্টুডিও দ্বারা চালিত
          </h2>
        </header>
        <p className="zHHBD-hotnow__intro">
          আমাদের{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> শক্তি পায় ইন্ডাস্ট্রি-লিডিং ক্রিয়েটরদের ঘনিষ্ঠ সহযোগিতা থেকে।
          ইনোভেশন, আর্টিস্ট্রি ও সার্টিফায়েড ইন্টেগ্রিটির জন্য যাঁরা বিখ্যাত—তাঁদের সঙ্গে মিলে আমরা দিই প্রিমিয়াম{" "}
          <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link" data-discover="true">ক্যাসিনো</Link> অভিজ্ঞতা—স্ট্যান্ডআউট টাইটেল ও ট্রাস্টেড টেকে ভরপুর।
        </p>
        <div className="zHHBD-hotnow__grid">
          <div className="zHHBD-hotnow__card">
            <h3 className="zHHBD-hotnow__card-title">ইনোভেশন—সবসময় সামনের সারিতে</h3>
            <p className="zHHBD-hotnow__card-text">
              আমাদের স্টুডিও নেটওয়ার্ক নিয়ত নতুন রিলিজ ও উদ্ভাবনী মেকানিকস যোগ করে লাইব্রেরিকে তরতাজা রাখে।
              একই{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> বারবার খেলায় আটকে থাকবেন না;
              বরং নিয়মিতই আবিষ্কার করবেন নতুন থিম, নতুন খেলার ধরন এবং বড় জয়ের নতুন পথ।
            </p>
          </div>
        </div>
        <div className="zHHBD-hotnow__cta">
          <a
            href="https://haruvest.com/fPdbvXy9"
            className="zHHBD-hotnow__btn"
            title="HHBD গেমস খেলুন"
          >
            HHBD গেমস খেলুন
          </a>
        </div>
        <figure className="zHHBD-hotnow__figure">
          <a
            href="https://haruvest.com/VRfKYjYj9"
            title="HHBD গেমস – বাংলাদেশে প্রিমিয়াম অনলাইন ক্যাসিনো টাইটেল এক্সপ্লোর করুন"
          >
            <img
              src={g4}
              alt="নীয়ন ক্যাসিনো সিনে এক ট্রেন্ডি প্লেয়ার—HHBD প্ল্যাটফর্মে অনলাইন পোকার খেলছেন।"
              title="HHBD গেমস – বাংলাদেশে প্রিমিয়াম অনলাইন ক্যাসিনো টাইটেল এক্সপ্লোর করুন"
              className="zHHBD-hotnow__img"
            />
          </a>
        </figure>
      </div>
    </section>
  </>





      )}
    </>
  );
};

export default Games;
